/* eslint-disable @typescript-eslint/no-magic-numbers */
/* eslint-disable @typescript-eslint/naming-convention */
import { AxiosInstance } from 'axios'

import { TResponse } from '@providers/models'
import { IWinterGetNFTs } from '@providers/models/winter'

export const getNFTsWinter = async (
    instance: AxiosInstance,
    email: string,
    projectId?: number,
): Promise<TResponse<IWinterGetNFTs[]>> => {
    const response = await instance.get<IWinterGetNFTs[]>('/getNFTs', {
        params: {
            email,
            project_id: projectId,
        },
    })

    if (response.status === 200)
        return {
            success: true,
            data: response.data.filter(item => {
                if (projectId) return item.project_id === projectId

                return item
            }),
        }

    return {
        success: false,
        error: response.data as unknown as string,
    }
}
